var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPenReqSel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 4,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.42184 19.9089H4.7687C4.40362 19.9089 4.10492 19.6037 4.10492 19.2306V4.03511C4.10492 3.662 4.40362 3.35674 4.7687 3.35674H15.8761C16.2411 3.35674 16.5398 3.662 16.5398 4.03511V9.69722C16.5398 10.0726 16.8363 10.3756 17.2036 10.3756C17.5709 10.3756 17.8674 10.0726 17.8674 9.69722V4.03511C17.8674 2.91354 16.9735 2 15.8761 2H4.7687C3.67124 2 2.77734 2.91354 2.77734 4.03511V19.2306C2.77734 20.3521 3.67124 21.2657 4.7687 21.2657H9.42184C9.78914 21.2657 10.0856 20.9627 10.0856 20.5873C10.0856 20.2119 9.78914 19.9089 9.42184 19.9089Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.64941 8.10547H13.7298",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72949 10.8186H12.7036",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72949 13.5325H10.2697",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72949 16.2454L9.58405 16.1775",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.64941 4.93945H13.7298",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.531 14.4966H16.2656V17.3478L18.3486 19.4766L19.2423 18.5633L17.531 16.8143V14.4966Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4594 11.3723C14.3167 11.3723 11.7705 13.9763 11.7705 17.1861C11.7705 20.396 14.3185 23 17.4594 23C20.602 23 23.1482 20.396 23.1482 17.1861C23.1482 13.9763 20.6002 11.3723 17.4594 11.3723ZM17.4594 21.7104C15.0186 21.7104 13.0341 19.6823 13.0341 17.1879C13.0341 14.6935 15.0186 12.6655 17.4594 12.6655C19.9002 12.6655 21.8846 14.6935 21.8846 17.1879C21.8846 19.6823 19.8984 21.7104 17.4594 21.7104Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenReqSel);
export default __webpack_public_path__ + "static/media/penReqSel.ac08adbf40a6d368226dc450ff1f6593.svg";
export { ForwardRef as ReactComponent };